import { render, staticRenderFns } from "./ApprovalRequestsPage.vue?vue&type=template&id=b432ee5a&scoped=true&lang=pug"
import script from "./ApprovalRequestsPage.vue?vue&type=script&lang=js"
export * from "./ApprovalRequestsPage.vue?vue&type=script&lang=js"
import style0 from "./ApprovalRequestsPage.vue?vue&type=style&index=0&id=b432ee5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b432ee5a",
  null
  
)

export default component.exports